import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { PdfExtractionFailed } from '@vy/ui-design-system';

export const ImportContractErrorState: React.FC = () => (
  <Stack
    sx={{
      alignItems: "center",
      justifyContent: "center",
      padding: 5,
      minHeight: 220
    }}>
    <Box sx={{ my: 1.5 }}>
      <PdfExtractionFailed />
    </Box>
    <Typography
      variant="body1"
      sx={{
        color: "text.secondary",
        fontWeight: 400,
        fontSize: 14
      }}>
      Contract extraction failed
    </Typography>
  </Stack>
);
